/*
 * TerriSTORY®
 *
 © Copyright 2022 AURA-EE
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Affero General Public License for more details.
 *
 * A copy of the GNU Affero General Public License should be present along
 * with this program at the root of current repository. If not, see
 * http://www.gnu.org/licenses/.
 */

import React, { useState } from "react";

/**
 * This component manages the display of the application footer
 */
function RegionalEmbeddedFooter(props) {
  var _props$parentApi$data, _props$parentApi$data2;
  const [display, setDisplay] = useState(true);
  let footer = {};
  footer.left = [];
  footer.right = [];
  if (props.parentApi && props.parentApi.data && (_props$parentApi$data = props.parentApi.data) !== null && _props$parentApi$data !== void 0 && (_props$parentApi$data2 = _props$parentApi$data.settings) !== null && _props$parentApi$data2 !== void 0 && _props$parentApi$data2.footer) {
    // Construction of the footer
    for (let dir of ["left", "right"]) {
      for (let block of JSON.parse(props.parentApi.data.settings.footer)[dir]) {
        let title = block.title;
        let subtitle = block.subtitle;
        let key = title + Date.now();
        let logos = [];
        for (let logo of block.logos) {
          logos.push(/*#__PURE__*/React.createElement("img", {
            key: logo.title,
            src: "/img/" + logo.img,
            alt: logo.title
          }));
        }
        footer[dir].push(/*#__PURE__*/React.createElement("div", {
          className: "embedded-footer-block",
          key: key
        }, /*#__PURE__*/React.createElement("label", null, title), /*#__PURE__*/React.createElement("div", null, logos), /*#__PURE__*/React.createElement("label", {
          className: "subtitle"
        }, subtitle)));
      }
    }
  }
  return /*#__PURE__*/React.createElement("div", {
    className: `embedded-footer-widgets ${display ? "" : "float-widget embedded-footer-closed"}`
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: display ? "embedded-footer-close-button" : "embedded-footer-open-button",
    "aria-label": display ? "Masquer" : "Accédez au graphique sur TerriSTORY",
    title: display ? "Masquer" : "Accédez au graphique sur TerriSTORY",
    onClick: () => setDisplay(!display)
  }, !display && /*#__PURE__*/React.createElement("i", {
    className: "bi bi-info-lg"
  }), display && /*#__PURE__*/React.createElement("div", {
    className: "bi bi-caret-left-fill",
    "aria-hidden": "true"
  })), display && /*#__PURE__*/React.createElement("div", {
    className: "infos-content embedded-footer"
  }, /*#__PURE__*/React.createElement("a", {
    href: "/",
    target: "_blank",
    rel: "noopener noreferrer"
  }, /*#__PURE__*/React.createElement("div", {
    className: "img-embedded-footer"
  }, /*#__PURE__*/React.createElement("img", {
    src: "../../img/logo_TerriSTORY_transparent.png",
    alt: "Logo de TerriSTORY\xAE",
    title: "Cliquez ici pour ouvrir ce graphique sur TerriSTORY et acc\xE9der \xE0 l'ensemble des fonctionnalit\xE9s"
  }))), footer["left"]));
}
export default RegionalEmbeddedFooter;